import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import useWindowSize from '../../../../hooks/useWindowSize';

import './RewardListingSkeleton.scss';

export default function RewardListingSkeleton() {
  const isMobile = useWindowSize();

  const renderCardInfoSkeleton = () => (
    <div className="cardInfo">
      <Skeleton width={40} height={40} className="infoSkeleton" />
      <Skeleton height={40} className="UICard" />
      <Skeleton width={40} height={40} className="UICard" />
      <Skeleton width={40} height={40} className="infoSkeleton" />
      <Skeleton height={40} className="UICard" />
      <Skeleton width={40} height={40} className="UICard" />
      <Skeleton width={40} height={40} className="infoSkeleton" />
      <Skeleton height={40} className="UICard" />
    </div>
  );

  const renderFilterTabsSkeleton = () => (
    <div className="tabSkeleton">
      {[...Array(5)].map((_, index) => (
        <Skeleton key={index} height={40} className='skeletonOne' />
      ))}
    </div>
  );

  const renderCardsSkeleton = () => (
    <div className="cardSection">
      {[...Array(12)].map((_, index) => (
        <div key={index} className="card">
          <Skeleton width={isMobile ? 140 : 195} height={126} className="icon" />
          <Skeleton width={100} height={20} className="margin_t_8" />
          <Skeleton width={140} height={20} className="margin_t_4" />
        </div>
      ))}
    </div>
  );

  return (
    <div className='RewardListingSkeletonWrapper'>
      <div className="headSection">
        <Skeleton height={isMobile ? 150 : 256} className="head" />
      </div>

      {!isMobile && <div className="bannerSkeleton"><Skeleton width={300} height={20} /></div>}

      <div className="nameInfo">
        <Skeleton circle width={40} height={40} />
        <Skeleton width={200} height={30} />
      </div>

      {renderCardInfoSkeleton()}

      <div className="tabSection"><Skeleton width={300} height={20} /></div>

      {isMobile && <div className="tabSection"><Skeleton width={100} height={40} /></div>}

      <div className="filterSection">
        <div className="rightSection">
          {renderFilterTabsSkeleton()}
          {renderCardsSkeleton()}
        </div>
      </div>

      <div className="bottomBanner"><Skeleton height={isMobile ? 150 : 260} className="banner" /></div>
    </div>
  );
};
